import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackPageview } from "@/lib/analytics";

/**
 * Mount once at the top of the app under <BrowserRouter>.
 * Emits a `$pageview` to PostHog on every route change.
 * No-ops when REACT_APP_POSTHOG_KEY is unset.
 */
export default function AnalyticsPageTracker() {
  const { pathname } = useLocation();
  useEffect(() => {
    trackPageview(pathname);
  }, [pathname]);
  return null;
}
